import React from 'react';
import {Grid, Typography, Container} from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';

import Header from './header.jsx'
import InputData from './InputData.jsx'
import Box from '@material-ui/core/Box';
import Output from './Output.jsx'
import Output1 from './Output1.jsx'
import Output2 from './Output2.jsx'
import Output3 from './Output3.jsx'


class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {alert:false};
    this.myRef = React.createRef();
  }

  handleChange = (state) =>{
    let c1 = state.age>=0&&state.age<=97;;
    let c2 = state.temperature>=36.2&&state.temperature<=40;
    let c3 = state.bmi>=5.19&&state.bmi<=66.79;
    let c4 = state.sex==1||state.sex==0;
    let c5 = state.ckd==1||state.ckd==0;
    let c6 = state.sob==1||state.sob==0;
    let c7 = state.cancer==1||state.cancer==0;
    let c8 = state.dm==1||state.dm==0;
    let c9 = true;

    let error_check = [c1,c2,c3,c4,c5,c6,c7,c8,c9]
    if(c1&&c2&&c3&&c4&&c5&&c6&&c7&&c8&&c9){
      this.setState({...state,alert:false,error_check,model:"M1"})
    }
    else{
      this.setState({alert:true,error_check})
    }
  }

  alert = ()=>{
    if(this.state.alert === true){
      return <Alert severity="error">Invalid Input</Alert>
    }
  }
  renderSwitch = (param,alert) => {
    console.log("submit is clicked")
    if(!alert){
      console.log(param)

      switch(param) {
        case "M1":
          return <Output1 data={this.state}></Output1>
        case "M2":
          return <Output2 data={this.state}></Output2>

        case "M3":
          return <Output3 data={this.state}></Output3>
        case "M4":
          return <Output data={this.state}></Output>
        default:
      }
    }

  }

  render(){
    return (
      <div className="App">
        <Grid container direction="column" spacing={3}>
            <Grid item><Header></Header></Grid>
            <Grid item container>
              <Grid item xs={1} />
              <Grid item xs={8} >
                  <Typography>
                    <Box fontWeight = "fontWeightBold" fontSize={25}>
                      Patient Information
                    </Box>
                  </Typography>
                  <div className="alert">
                      {this.alert()}
                  </div>
                  <InputData onSubmit={this.handleChange}></InputData>
                  <Typography>
                    <Box fontWeight = "fontWeightBold" fontSize={25}>
                      Predicted Result
                    </Box>
                  </Typography>
                  <div className="Output">
                    {this.renderSwitch(this.state.model,this.state.alert)}
                  </div>

              </Grid>
              <Grid item xs={1} />
            </Grid>
            <footer class="footer">
              <Typography align="center" >

              <Box fontSize={15} >
                <br/>
                <br/> Version 1.0.0 by October 15, 2020.
                <br/> Created by BIBS Labratory, Seoul National University
                <br/> Developed and Maintained by Chanhee Lee, lch951022@gmail.com
              </Box>
            </Typography>

            </footer>
        </Grid>


      </div>

    );
  };
}

export default App;
